import { buildRpaDomainSeoBundle } from "../rpaSeoUtils";

export const AGRICULTURE_DOMAIN_INTRO = {
  title: "Agriculture & Food Processing",
  content: "Document AI + RPA and workflow automation across Food Procurement. Each use case includes challenge and solution detail, process diagrams, and human-in-the-loop review for enterprises in India, UAE, KSA, UK, and USA.",
  seoDescription: "Agriculture & Food Processing automation use cases — document AI + RPA and workflow automation across Food Procurement. Validation, approvals, system updates, and exception handling.",
};

const slugify = (label) =>
  label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

function withMeta(uc) {
  return {
    ...uc,
    groupId: slugify(uc.subIndustry),
    seoTitle: uc.title,
    title: uc.shortTitle || uc.title,
    systems: uc.systems || SYSTEMS,
  };
}

const SYSTEMS = "ERP, QMS, CRM, Traceability System, Email, Power BI";

const RAW = [
  {
    id: "supplier-invoice-and-weighbridge-reconciliation",
    subIndustry: "Food Procurement",
    department: "Finance",
    businessProcess: "Supplier invoice and weighbridge reconciliation",
    regions: "India, UAE/Dubai, KSA/Saudi Arabia, UK, USA",
    shortTitle: "Supplier invoice and weighbridge reconciliation",
    title: "Supplier Invoice And Weighbridge Reconciliation Automation for Agriculture & Food Processing",
    seoKeywords: "agriculture & food processing, supplier invoice and weighbridge reconciliation, AI automation, RPA, agentic AI, document AI",
    challenge: "Supplier invoices are manually matched with weighbridge slips, quality deductions and PO terms.",
    solution: "Implement Document AI + RPA to capture inputs, validate rules, route exceptions, generate summaries or actions, and update the target systems with human approval where required.",
    automationType: "Document AI + RPA",
    buyerPersona: "Finance Head, Procurement Head",
    systems: "ERP, Weighbridge, Procurement System, Email",
    agentsRequired: "Document Extraction Agent, Supplier Validation Agent, Exception Agent",
    inputData: "Forms, PDFs, emails, scanned documents, attachments, master data and supplier invoice and weighbridge reconciliation rules",
    outputActions: "Extracted structured data, validation results, exception list and approval-ready supplier invoice and weighbridge reconciliation record",
    keyBenefits: "Faster Closure, Fewer Reconciliation Errors, Reduced Manual Effort And Better Finance Visibility",
    roiTimeline: "3-6 months",
    implementationComplexity: "Medium",
    businessImpact: "High",
  },
];
export const AGRICULTURE_USE_CASES = RAW.map(withMeta);
const GROUP_ORDER = ["Food Procurement"];
export const AGRICULTURE_GROUPS = GROUP_ORDER.map((label) => ({
  id: slugify(label),
  label,
})).filter((g) => AGRICULTURE_USE_CASES.some((uc) => uc.groupId === g.id));
const seo = buildRpaDomainSeoBundle({
  domainSlug: 'agriculture-food-processing-domain',
  domainIntro: AGRICULTURE_DOMAIN_INTRO,
  useCases: AGRICULTURE_USE_CASES,
});
export const AGRICULTURE_USE_CASES_SEO = seo.useCasesSeo;
export const AGRICULTURE_DOMAIN_FAQS = seo.domainFaqs;
export const AGRICULTURE_ITEM_LIST_JSONLD = seo.itemListJsonLd;
export const AGRICULTURE_FAQ_JSONLD = seo.faqJsonLd;
export const AGRICULTURE_BREADCRUMB_JSONLD = seo.breadcrumbJsonLd;
export const AGRICULTURE_WEBPAGE_JSONLD = seo.webPageJsonLd;

